export const getAmountTotalCellStyles = () => ({
  AmountTotalCell: {
    width: '100%',
  },
  AmountTotalCellWithPadding: {
    paddingTop: 11,
    paddingBottom: 11,
    paddingLeft: 12,
    paddingRight: 8,
  },
  AmountTotalItem: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontWeight: 600,
  },
  GreenColor: {
    color: '#107C10',
  },
});
